import { Dumbbell, HeartPulse, Users } from "lucide-react";

const PILLARS = [
  { icon: Dumbbell, label: "Strength & Conditioning" },
  { icon: HeartPulse, label: "Rehabilitation Focus" },
  { icon: Users, label: "All Ages & Abilities" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#09090B] border-t border-zinc-800 noise-overlay"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden border border-zinc-800 bg-zinc-900">
            <img
              src="https://customer-assets.emergentagent.com/job_je-fitness-hub/artifacts/5f72iicu_copy_4AF68C85-FDB8-420E-8AB8-B134B576B5CC.png"
              alt="Jamie — JE Training coach"
              className="h-full w-full object-contain"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-5 -right-3 lg:-right-5 bg-[#D4AF37] text-zinc-950 px-6 py-5">
            <p className="font-display text-4xl font-black leading-none tracking-tight">100%</p>
            <p className="mt-1 font-display text-xs uppercase tracking-[0.2em] font-bold">
              Focused on you
            </p>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[2px] w-12 bg-[#D4AF37]" />
            <p className="font-display text-[#D4AF37] text-sm font-bold tracking-[0.3em] uppercase">
              The Coach
            </p>
          </div>
          <h2
            data-testid="about-heading"
            className="font-display text-white font-black uppercase tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl"
          >
            Meet <span className="text-[#D4AF37]">Jamie.</span>
          </h2>

          <div className="relative mt-8">
            <span className="absolute -top-6 -left-2 font-display text-[#D4AF37]/20 text-8xl font-black leading-none select-none">
              &ldquo;
            </span>
            <p className="relative text-zinc-300 text-lg lg:text-xl leading-relaxed font-light max-w-2xl">
              I've built JE Training on two simple principles: strength and
              togetherness. Whether you're stepping into a gym for the first
              time, rebuilding confidence after injury, or pushing for a new
              personal best — every programme is tailored, progressive and
              genuinely accountable.
            </p>
          </div>
          <p className="mt-5 text-zinc-500 text-base leading-relaxed font-light max-w-2xl">
            Based in Braintree, Essex. My goal is simple: sustainable results
            through honest coaching, smart programming and a training culture
            you actually want to return to.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {PILLARS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`about-pillar-${i}`}
                  className="border border-zinc-800 bg-zinc-900/50 p-5 hover:border-[#D4AF37]/40 transition-colors duration-300"
                >
                  <Icon size={20} strokeWidth={1.5} className="text-[#D4AF37]" />
                  <p className="mt-4 font-display text-white text-base font-bold uppercase tracking-[0.08em]">
                    {p.label}
                  </p>
                </div>
              );
            })}
          </div>

          <a
            href="#contact"
            data-testid="about-enquire-cta"
            className="mt-10 inline-flex items-center gap-3 border border-[#D4AF37]/50 hover:border-[#D4AF37] hover:bg-[#D4AF37] hover:text-zinc-950 text-[#D4AF37] px-8 py-4 font-display text-base font-bold uppercase tracking-[0.16em] transition-colors duration-300"
          >
            Start Your Journey — Enquire
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
